import { CONSTANTS } from "@/constants";

export async function request(url: string, init: RequestInit = {}) {
    const requestInit = init;
    let requestUrl = url;

    if (!url.startsWith('http')) {
        requestUrl = `${CONSTANTS.BASE_URL}${url}`;
    }

    requestInit.headers = {
        ...requestInit.headers,
        'Content-Type': 'application/json',
    };

    return fetch(requestUrl, requestInit);
}
